<template>
    <div class="mamMaster-follow-setting follow-setting">
        <div class="content pc-padding30-mobil-padding20 white border-radius5">
            <el-form
            >
                <el-form-item>
                    <p class="self-label">{{$t('withgold.accountNumber')}}</p>
                    <el-input
                            disabled
                            :value="login"></el-input>
                </el-form-item>
                <el-form-item>
                    <p class="self-label">{{$t('nickname')}}</p>
                    <el-input
                            disabled
                            :value="alias"></el-input>
                </el-form-item>
                <el-form-item>
                    <p class="self-label">
                      <account-role-tips></account-role-tips>
                    </p>
                    <el-input disabled :value="$t('MAM_Investment_Account')"></el-input>
                </el-form-item>
            </el-form>
            <mam-sub-follow-setting
                ref="editform"
                :form-data="formData"
                @send-form="sendFormHandle"
            >
            </mam-sub-follow-setting>
        </div>
      <el-button
        class="save-btn"
        type="primary"
        @click="saveHandle"
      >{{$t('User.saveSetting')}}</el-button>
    </div>
</template>

<script>
    import accountRoleTips from '@/components/public/accountRoleTips'
    import { queryLoginConfig, updateLoginConfig } from '@/api/config'
    import mamSubFollowSetting from '@/components/common/mamSubFollowSetting'
  export default {
    name: 'index',
    components:{
      mamSubFollowSetting,
      accountRoleTips
    },
    props: {
      accountMtId: {
        type: Number,
        default: 0
      },
    },
    data() {
      return {
        formData:{
          stopRatio: ''
        },
        alias: '',
        login: '',
      };
    },
    created(){
      this.queryConfig();
    },
    methods: {
      queryConfig(){
        queryLoginConfig({
          mtId: this.accountMtId,
        }).then((res) => {
          this.login = res.data.login;
          this.alias = res.data.alias;
          this.formData.stopRatio = res.data.stopLoss || '';
        })
      },
      saveHandle(){
        this.$refs.editform.validate();
      },
      sendFormHandle(form){
        // ajax
        updateLoginConfig({
          mtId: this.accountMtId,
          stopLoss: form.stopRatio,
        }).then((res) => {
          this.$message({
            type: 'success',
            message: this.$t('Saved_successfully')
          })
        })
      },
    }
  };
</script>

<style lang="scss" scoped>
.mamMaster-follow-setting {
    .module-header {
        height: 60px;
        line-height: 60px;
    }
    .tips-icon {
        color: #cccccc;
    }
    .input-prefix-outer {
        .prefix {
            left: 15px;
            top: 50%;
            transform: translateY(-50%);
            color: #333333;
            z-index: 99;
        }
        /deep/ .input-prefix-ele .el-input__inner{
            padding-left: 100px;
        }
    }
    .suffix {
        right: 15px;
        top: 50%;
        transform: translateY(-50%);
        color: #333333;
        z-index: 99;
    }
  .save-btn {
    margin-top: 24px;
  }
}
</style>
